import React from 'react';
import { CheckCircle, XCircle, Info, AlertTriangle } from 'lucide-react';
import { useApp } from '../context/AppContext';

const icons = {
  success: <CheckCircle size={28} />,
  error: <XCircle size={28} />,
  info: <Info size={28} />,
  warning: <AlertTriangle size={28} />,
};

export default function AlertBox() {
  const { alert, closeAlert } = useApp();
  if (!alert) return null;
  return (
    <div className="alert-overlay" onClick={closeAlert}>
      <div className="alert-box" onClick={e => e.stopPropagation()}>
        <div className={`alert-icon ${alert.type}`}>{icons[alert.type]}</div>
        <div className="alert-title">{alert.title}</div>
        <div className="alert-msg">{alert.message}</div>
        <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={closeAlert}>OK</button>
      </div>
    </div>
  );
}
